/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


/* ============================================================
   SKULLWAVE – Optimisations de performance mobile
   ============================================================ */

(function() {
  'use strict';

  /* 1. Lazy-loading des images non critiques
  ------------------------------------------
  Ajoute loading="lazy" sur les images hors-viewport qui n'ont
  pas encore cet attribut, pour réduire le travail initial du navigateur. */
  function lazyLoadImages() {
    var imgs = document.querySelectorAll('img:not([loading])');
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          entry.target.setAttribute('loading', 'lazy');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });
    imgs.forEach(function(img) { io.observe(img); });
  }

  /* 2. content-visibility sur le feed Instagram
  -----------------------------------------------
  Réduit le travail de rendu sur le feed Instagram en le marquant
  comme non critique tant qu'il n'est pas proche du viewport. */
  function deferInstafeed() {
    var feedSection = document.querySelector('[class*="instafeed"]');
    if (!feedSection) return;
    var section = feedSection.closest('.shopify-section');
    if (!section) return;
    if (!('IntersectionObserver' in window)) return;

    // Masquer les vidéos Instagram tant que non visibles
    var instaVideos = section.querySelectorAll('video[src*="instagram"], video[src*="cdninstagram"]');
    instaVideos.forEach(function(v) {
      var src = v.src;
      v.removeAttribute('src');
      v.dataset.lazySrc = src;
    });

    var io = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Restaurer les vidéos quand la section est visible
          var videos = entry.target.querySelectorAll('video[data-lazy-src]');
          videos.forEach(function(v) { v.src = v.dataset.lazySrc; });
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '400px' });

    io.observe(section);
  }

  /* 3. Delay smile.io initialisation jusqu'à interaction utilisateur
  -------------------------------------------------------------------
  Réduit le TBT en ne faisant pas tourner Smile tant que
  l'utilisateur n'a pas interagi avec la page. */
  function delaySmile() {
    if (typeof window.Smile === 'undefined') return;
    var events = ['scroll', 'mousemove', 'touchstart', 'keydown'];
    var triggered = false;
    function initSmile() {
      if (triggered) return;
      triggered = true;
      events.forEach(function(e) { window.removeEventListener(e, initSmile); });
      if (window.Smile && typeof window.Smile.init === 'function') {
        window.Smile.init();
      }
    }
    events.forEach(function(e) { window.addEventListener(e, initSmile, { passive: true }); });
    // Fallback : initialiser après 5s de toute façon
    setTimeout(initSmile, 5000);
  }

  /* Initialisation après chargement complet */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      lazyLoadImages();
      deferInstafeed();
    });
  } else {
    lazyLoadImages();
    deferInstafeed();
  }

  window.addEventListener('load', delaySmile);

})();
